import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-0 pb-3 pt-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Cookiepolitik", -1)
const _hoisted_3 = { class: "w-percent-100 w-percent-100-child" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Læs her om brugen af cookies på denne hjemmeside.", -1)
const _hoisted_5 = { class: "accordion accordion-multiselectable" }
const _hoisted_6 = {
  class: "accordion-button",
  "aria-expanded": "false",
  "aria-controls": "a1"
}
const _hoisted_7 = {
  id: "a1",
  "aria-hidden": "true",
  class: "accordion-content"
}
const _hoisted_8 = {
  class: "accordion-button",
  "aria-expanded": "false",
  "aria-controls": "a2"
}
const _hoisted_9 = {
  id: "a2",
  "aria-hidden": "true",
  class: "accordion-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_RichTekst = _resolveComponent("RichTekst")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createElementVNode("h2", null, [
            _createElementVNode("button", _hoisted_6, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.cookies.accordion.header.1' }, null, 8, ["tekstNoegle"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, [
              _createVNode(_component_RichTekst, { tekstNoegle: 'tco.cookies.accordion.text.1' }, null, 8, ["tekstNoegle"])
            ])
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("h2", null, [
            _createElementVNode("button", _hoisted_8, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.cookies.accordion.header.2' }, null, 8, ["tekstNoegle"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, [
              _createVNode(_component_RichTekst, { tekstNoegle: 'tco.cookies.accordion.text.2' }, null, 8, ["tekstNoegle"])
            ])
          ])
        ])
      ])
    ])
  ]))
}